export default __webpack_public_path__ + "static/media/ny.7ec0692d.png";